export const fetcher = async <T>(url: string): Promise<T> => {
    const res = await fetch(url);
    const data = await res.json();
    if (!res.ok || !data.success)
        throw new Error(data.message || "Failed to fetch data");
    return data.data;
};
